import Phaser from 'phaser';
import { BootScene } from '@/scenes/BootScene';
import { MainScene } from '@/scenes/MainScene';
import { UIScene } from '@/scenes/UIScene';
import { BenScene } from '@/scenes/BenScene';
import { FPSScene } from '@/scenes/FPSScene';
import { GAME_WIDTH, GAME_HEIGHT } from '@/config';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  parent: document.body,
  backgroundColor: '#0a0a0a',
  scene: [BootScene, MainScene, UIScene, BenScene, FPSScene],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    mouse: {
      preventDefaultWheel: true,
    },
  },
  render: {
    pixelArt: true,
    antialias: false,
  },
};

new Phaser.Game(config);
